export default "__VITE_ASSET__DiHvLkhW__"